import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=2738f7f1&scoped=true&"
import script from "./Feature.vue?vue&type=script&lang=js&"
export * from "./Feature.vue?vue&type=script&lang=js&"
import style0 from "./Feature.vue?vue&type=style&index=0&id=2738f7f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2738f7f1",
  null
  
)

export default component.exports